import { ButtonType, UiComponentSize } from '@altibox/design-system-component-lib';
import React from 'react';

import { useLargeTabletMediaQuery } from 'app/utils/breakpoints-utils';

import { StyledButton, StyledCard } from './card.styled';

interface CardProps {
    children: React.ReactNode;
    buttonText: string;
    onButtonClick: () => void;
    disabled?: boolean;
}

type Props = CardProps;

export const Card: React.FC<Props> = (props) => {
    const { children, onButtonClick, buttonText, disabled, ...rest } = props;

    const isOnLargeTablet = useLargeTabletMediaQuery();

    return (
        <StyledCard {...rest}>
            {children}
            <StyledButton
                onClick={onButtonClick}
                buttonType={ButtonType.PRIMARY_B}
                uiComponentSize={isOnLargeTablet ? UiComponentSize.MEDIUM : UiComponentSize.LARGE}
                disabled={disabled}
            >
                {buttonText}
            </StyledButton>
        </StyledCard>
    );
};
